import { Router } from '@angular/router';
import { TemplateRef } from '@angular/core';
import { Grid } from '../../../../shared/Models/grid';
import { ActionColumn, ActionItem } from '../../../../shared/Models/columns';
import { Part } from '../../../Models/Part';
import { PartsService } from '../../../Services/parts.service';
import { createBasePartsGridConfig } from './base-parts-grid.config';

export function createArchivePartsGridConfig(
  router: Router,
  partsService: PartsService,
  partRowDetail: TemplateRef<any>,
  onReAdd: (row: Part) => void
): Grid {
  const actionColumn = <ActionColumn>{
    name: 'global.actions',
    prop: null,
    type: ActionColumn.type,
    sortable: false,
    translate: true,
    actionItems: [
      <ActionItem>{
        icon: 'feather icon-plus',
        tooltip: 'global.readd',
        onclick: onReAdd,
        showCallback: (row: Part) => row,
        btnClass: 'ripple light'
      },
    ]
  };

  return createBasePartsGridConfig({
    router,
    partsService,
    partRowDetail,
    showButton: true,
    archive: true,
    additionalColumns: [actionColumn]
  });
} 